import { sql } from "drizzle-orm";

import type { WsCallRecord } from "@storyboard/web-client";
import { bulkInsert } from "@/db/bulkInsert";
import { callRecord } from "@/db/schema";
import { deduplicateByKeyValue } from "@/models/appSyncFunctions.ts";
import { emitTableUpdates } from "@/models/eventing/TableEventManager";

function transformWsCallRecord(r: WsCallRecord) {
  return {
    id: r.id,
    contentId: r.contentId,
    fromAccountId: r.fromAccountId,
    fromDisplayName: r.fromDisplayName,
    fromAlias: r.fromAlias,
    toAccountId: r.toAccountId,
    toDisplayName: r.toDisplayName,
    toAlias: r.toAlias,
    durationSeconds: r.durationSeconds,
    callStatus: r.callStatus,
    createdAt: r.createdAt,
  };
}

export async function bulkUpsertCallRecord(records: WsCallRecord[], deferEmit = false) {
  if (records.length === 0) return;
  const data = records.map((record) => transformWsCallRecord(record));
  const deduped = deduplicateByKeyValue(data, (item) => item.id);
  await bulkInsert(callRecord, deduped, {
    onConflict: {
      type: "doUpdate",
      target: [callRecord.id],
      set: {
        contentId: sql`"excluded"."contentId"`,
        fromAccountId: sql`"excluded"."fromAccountId"`,
        fromDisplayName: sql`"excluded"."fromDisplayName"`,
        fromAlias: sql`"excluded"."fromAlias"`,
        toAccountId: sql`"excluded"."toAccountId"`,
        toDisplayName: sql`"excluded"."toDisplayName"`,
        toAlias: sql`"excluded"."toAlias"`,
        durationSeconds: sql`"excluded"."durationSeconds"`,
        callStatus: sql`"excluded"."callStatus"`,
        createdAt: sql`"excluded"."createdAt"`,
      },
    },
  });
  if (!deferEmit) {
    emitTableUpdates(["call_record"]);
  }
}
